import { AbstractProgress } from 'foundations-components/transitional/components/AbstractProgress';
import { NanoProgress } from 'foundations-components/transitional/components/NanoProgress';
import { jsx as _jsx } from "react/jsx-runtime";
const ConditionalPropertiesPanelProgress = () => {
  return /*#__PURE__*/_jsx(AbstractProgress, {
    incrementFactor: 0.1,
    maximum: 95,
    render: ({
      value,
      done
    }) => /*#__PURE__*/_jsx("div", {
      style: {
        position: 'relative'
      },
      children: /*#__PURE__*/_jsx(NanoProgress, {
        value: value,
        animateOnComplete: done
      })
    })
  });
};
export default ConditionalPropertiesPanelProgress;